import React, { useState } from 'react';
import api from '../services/api';
import { useParams, useNavigate } from 'react-router-dom';

const ResetPasswordConfirm: React.FC = () => {
  const { uid, token } = useParams<{ uid: string; token: string }>();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setStatus('error');
      setMessage('As senhas não conferem.');
      return;
    }

    setStatus('loading');
    try {
      await api.post('password_reset/confirm_reset/', {
        uid,
        token,
        password
      });
      setStatus('success');
      setTimeout(() => navigate('/login'), 3000);
    } catch (error) {
      setStatus('error');
      setMessage('Link inválido ou expirado.');
    }
  };

  return (
    <div className="login-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <div className="login-box card" style={{ width: '100%', maxWidth: '400px', padding: '40px' }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h2 style={{ color: 'var(--primary-blue)', fontSize: '1.5rem', marginBottom: '10px' }}>Nova Senha</h2>
          <p style={{ color: 'var(--text-secondary)' }}>Crie uma nova senha para sua conta.</p>
        </div>
        
        {status === 'success' ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ color: 'var(--success)', marginBottom: '20px', fontSize: '3rem' }}>✓</div>
            <p>Senha alterada com sucesso!</p>
            <p style={{ fontSize: '0.9rem', color: 'var(--text-secondary)' }}>Redirecionando para o login...</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Nova Senha</label>
              <input 
                type="password" 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
                required 
                minLength={8}
              />
            </div>
            <div className="form-group">
              <label>Confirmar Senha</label>
              <input 
                type="password" 
                value={confirmPassword} 
                onChange={(e) => setConfirmPassword(e.target.value)} 
                required 
                minLength={8}
              />
            </div>
            
            {status === 'error' && (
              <div style={{ color: 'var(--danger)', marginBottom: '15px', fontSize: '0.9rem' }}>{message}</div>
            )}

            <button type="submit" className="btn" style={{ width: '100%', marginTop: '10px', padding: '12px' }} disabled={status === 'loading'}>
              {status === 'loading' ? 'Salvando...' : 'Alterar Senha'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPasswordConfirm;
